import { render } from "./CheckBoxForm.vue?vue&type=template&id=0494d5fc&ts=true"
import script from "./CheckBoxForm.vue?vue&type=script&lang=ts"
export * from "./CheckBoxForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/CheckBoxForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0494d5fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0494d5fc', __exports__)) {
    api.reload('0494d5fc', __exports__)
  }
  
  module.hot.accept("./CheckBoxForm.vue?vue&type=template&id=0494d5fc&ts=true", () => {
    api.rerender('0494d5fc', render)
  })

}


export default __exports__